<template>
	<router-link :to="nav.path" v-if="checkRequire(nav) && !nav.blank">
		<slot></slot>
	</router-link>
	<span v-else-if="nav.path === '#'">
		<slot></slot>
	</span>
	<a :href="nav.path" v-else-if="checkRequire(nav)">
		<slot></slot>
	</a>
</template>
<script>
	import Vuex from 'vuex';

	export default {
		name: 'nav-link',
		props: [
			'nav'
		],
		data() {
			return {}
		},
		computed: {
			...Vuex.mapGetters({
				userLogedIn: 'getUserStatus'
			})
		},
		methods: {

			checkRequire(navItem) {
				return !navItem.login || (navItem.login && this.userLogedIn);
			}
		}
	}

</script>